<template>
  <v-flex style="display: flex; border-bottom: 1px solid #eee" justify-start>
    <f-time :offset="event.timeOffset" style="width: 10%"></f-time>
    <v-tooltip top style="width: 10%">
      <v-icon slot="activator">swap_horiz</v-icon>
      <span>Substitution</span>
    </v-tooltip>
    <div style="display: flex; flex-grow: 1; align-items:center">
      <f-flag
        v-if="teamA.players.indexOf(event.noPlayerIn) !== -1"
        :code="teamA.code"
        :alt="teamA.code"
        :height="20"
      ></f-flag>
      <f-flag
        v-if="teamB.players.indexOf(event.noPlayerIn) !== -1"
        :code="teamB.code"
        :alt="teamB.code"
        :height="20"
      ></f-flag>
      <span style="width: 5%">{{ players[event.noPlayerIn].noShirt }}</span>
      <strong class="green--text" style="text-align: left; width: 15%">{{ players[event.noPlayerIn].volleyballPlayer.teamNamePlayer }}</strong>
      <v-icon style="width: 10%">swap_horiz</v-icon>
      <span style="width: 5%">{{ players[event.noPlayerOut].noShirt }}</span>
      <strong class="red--text" style="text-align: left; width: 15%">{{ players[event.noPlayerOut].volleyballPlayer.teamNamePlayer }}</strong>
    </div>
  </v-flex>
</template>

<script>
import Time from './Time'
import Flag from '@/components/Flag'

export default {
  props: ['event', 'players', 'teams', 'teamA', 'teamB'],

  components: {
    'f-time': Time,
    'f-flag': Flag,
  },
}
</script>




// WEBPACK FOOTER //
// src/components/MatchLive/PlayByPlay/Substitution.vue